import React from "react";
import { cn } from "@/lib/utils";

/**
 * Minimal loading state for LLM re-ranking on the List (LTO) page.
 * Wordless and compact — distinct from the catalog search animation.
 */
export const AiRerankLoadingLto: React.FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <div
      role="status"
      className={cn(
        "flex items-center justify-center gap-3 py-10",
        className,
      )}
    >
      <span className="sr-only">Loading ranked results</span>
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          className="relative h-20 w-24 animate-pulse rounded-lg border border-sky-200/60 bg-sky-50/50 dark:border-sky-800/40 dark:bg-sky-950/20"
          style={{ animationDelay: `${i * 200}ms` }}
        >
          <div className="absolute bottom-3 left-3 right-3 space-y-1.5">
            <div className="h-1.5 w-3/4 rounded-full bg-sky-200/70 dark:bg-sky-800/50" />
            <div className="h-1.5 w-1/2 rounded-full bg-sky-200/50 dark:bg-sky-800/30" />
          </div>
        </div>
      ))}
    </div>
  );
};
